import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedFormations = [], onDeleteSelected, onClearSelection, onDuplicateSelected }) => {
  const handleDeleteSelected = async () => {
    if (!selectedFormations.length) return;
    
    try {
      await onDeleteSelected(selectedFormations);
      showSuccess(`${selectedFormations.length} formation(s) supprimée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des formations');
      console.error(error);
    }
  };
  
  const handleDuplicateSelected = async () => {
    if (!selectedFormations.length) return;
    
    try {
      await onDuplicateSelected(selectedFormations);
      showSuccess(`${selectedFormations.length} formation(s) dupliquée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la duplication des formations');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de formations sélectionnées
  if (!selectedFormations.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedFormations.length} formation{selectedFormations.length > 1 ? 's' : ''} sélectionnée{selectedFormations.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke", styles.button)} onClick={handleDuplicateSelected}>
          <Icon name="copy" size="24" />
          <span>Dupliquer</span>
        </button>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
